__webpack_require__.p = "/Digital-card/";